import React from 'react';
import 'remixicon/fonts/remixicon.css';
import { cn } from "~/lib/utils";

export interface IconProps extends React.HTMLAttributes<HTMLElement> {
  name: string;
  size?: 'button-lg' | 'button-default' | 'button-xs' | 'button-2xs' | number;
  className?: string;
}

const sizeMap = {
  'button-lg': 18,
  'button-default': 16,
  'button-xs': 18,
  'button-2xs': 16,
};

export const Icon = React.forwardRef<HTMLElement, IconProps>(
  ({ name, size = 'button-default', className, ...props }, ref) => {
    const iconSize = typeof size === 'number' ? size : sizeMap[size];
    
    return (
      <i
        ref={ref as React.Ref<HTMLElement>}
        className={cn(`ri-${name}`, className)}
        style={{ fontSize: iconSize, lineHeight: 1 }}
        {...props}
      />
    );
  }
);

Icon.displayName = "Icon"; 